import { isDocsPath } from '@pos/docs/path';
import { lazy, Suspense } from 'react';
import { useLocation } from 'react-router';
import { App } from './App';

// The public user guide is its own chunk, loaded only for /docs, so the admin bundle does not grow.
const DocsApp = lazy(() => import('@pos/docs').then((m) => ({ default: m.DocsApp })));

/**
 * /docs is public: it renders here, before App and its login gate, so it needs no session and makes no API call.
 * Every other path goes to App as before.
 */
export function Root() {
  const { pathname } = useLocation();
  if (isDocsPath(pathname)) {
    return (
      <Suspense fallback={null}>
        <DocsApp />
      </Suspense>
    );
  }
  return <App />;
}
